import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "14",
  height: "12",
  viewBox: "0 0 14 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M13.5935 4.95518L13.9997 0L9.45762 2.12971L10.7364 3.00329L8.05404 6.3869L6.99847 5.48039C6.15733 4.75803 4.8802 4.86046 4.16774 5.70742L0.229818 10.3887C-0.121163 10.8059 -0.0636919 11.4256 0.358183 11.7727C0.780058 12.1198 1.40658 12.063 1.75756 11.6458L5.69548 6.96446L6.75105 7.87097C7.60931 8.60803 8.91667 8.48428 9.61799 7.5996L12.3745 4.12239L13.5935 4.95518Z",
      fill: "white"
    }, null, -1)
  ]))]))
}
export default { render: render }